module.exports = __webpack_public_path__ + "img/packages/labels-preview-stb.349c95.jpg";